import 'select2';
import $ from 'jquery';
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const allArticles = document.querySelectorAll('.tjs-our-portfolio__article');
const searchField = document.querySelector('.tjs-filters__search');
const industryFilter = document.querySelector('.tjs-filters__select--industry');
const currentFilter = document.querySelector('.tjs-filters__select--current');
const form = document.querySelector('.tjs-filters__form');
const nothingMessage = document.querySelector('.tjs-our-portfolio__nothing');
const exitedBtn = document.querySelector('.tjs-our-portfolio__bottom-link');

function getURLparams() {
  let url = new URL(document.URL)
  let searchParams = url.searchParams
  let paramsObject = {}
  searchParams.forEach((value, key) => paramsObject[key] = value)
  return paramsObject
}

(() => {
  const currentValue = document.querySelector("[data-filter='true']").value;
  for (const article of allArticles) {
    if (!article.classList.contains(currentValue)) {

      article.classList.add('hide');
      const popupLink = article.querySelector('.tjs-our-portfolio__article-link');
      if (popupLink.hasAttribute("data-fancybox")) delete popupLink.dataset.fancybox;

    }
  }
})();

function initSelect() {
  $('.tjs-filters__select--industry').select2().on("change", searchArticles);
  $('.tjs-filters__select--current').select2().on("change", searchArticles);
  $('.tjs-filters__select--current').select2({
    templateSelection: function (data) {
        return (data.element.className === "parent") ? data.text : (data.element.className === "") ? data.text : `${data.element.className}: ${data.text}`;
    },
  });
}

document.addEventListener('DOMContentLoaded', function (){
  initSelect();
});

function searchArticles(e) {
  if (e && ((e.keyCode === 16 && e.keyCode === 9) || e.keyCode === 16 || e.keyCode === 9)) return;
  if (e) e.preventDefault();

  const searchValue = searchField.value.toLowerCase();
  const committeeValue = industryFilter.value;
  const currentValue = currentFilter.value;

  changeCurrUrl(committeeValue, currentValue);

  if (nothingMessage.classList.contains('visible')) nothingMessage.classList.remove('visible');

  for (const article of allArticles) {
    const popupLink = article.querySelector('.tjs-our-portfolio__article-link');
    const preArticle = article.querySelector('.pre-article-row');
    const articleTitle = article.querySelector('.tjs-our-portfolio__article-title');
    let titleText = '';
    if (articleTitle !== null) titleText = articleTitle.textContent.toLowerCase();
    if (titleText.includes(searchValue) && (committeeValue === '0' || article.classList.contains(committeeValue)) && (currentValue === '0' || article.classList.contains(currentValue))) {
      if (article.classList.contains('hide')) article.classList.remove('hide');
      if (!popupLink.hasAttribute("data-fancybox") && !preArticle) popupLink.dataset.fancybox = "dialog";
    } else {
      article.classList.add('hide');
      if (popupLink.hasAttribute("data-fancybox")) delete popupLink.dataset.fancybox;
    }
  }

  const visibleArticles = document.querySelectorAll('.tjs-our-portfolio__article:not(.hide)');

  if (visibleArticles.length === 0) nothingMessage.classList.add('visible');
  let parentBlocks = document.querySelectorAll(".inner-pre-resolute-wrapper");
  parentBlocks.forEach(function(parentBlock) {
      let childBlocks = parentBlock.querySelectorAll(".tjs-our-portfolio__article:not(.hide)");
      let hasChildWithoutClass = childBlocks.length > 0;
      parentBlock.style.display = hasChildWithoutClass ? "block" : "none";

  });
}

function changeCurrUrl(commVal, teamVal) {
  let url = window.location.href.split('?')[0];
  const committeeCurrElem = industryFilter.querySelector(`option[value="${commVal}"]`).textContent;
  const teamCurrElem = currentFilter.querySelector(`option[value="${teamVal}"]`).value;
  let newUrl;

  if (+commVal !== 0 && +teamVal !== 0) {
    newUrl = url + '?in=' + sanitizedURLVal(committeeCurrElem) + '&st=' + sanitizedURLVal(teamCurrElem);
  } else if (+commVal !== 0) {
    newUrl = url + '?in=' + sanitizedURLVal(committeeCurrElem);
  } else if (+teamVal !== 0) {
    newUrl = url + '?st=' + sanitizedURLVal(teamCurrElem);
  } else {
    newUrl = url;
  }
  window.history.pushState({path: newUrl}, '', newUrl);
}

const sanitizedURLVal = (text) => {
  const str = text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-")
  return encodeURIComponent(str);
}

form.addEventListener('submit', searchArticles);
searchField.addEventListener('keyup', searchArticles);

Fancybox.bind('[data-fancybox]',{
  caption: function (fancybox, carousel, slide) {
    return `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption;
  }, keyboard: {
    ArrowUp: false,
    ArrowDown: false,
  },
});
Fancybox.defaults.Hash = false;

// Simulate clicking on next/prev buttons (Fancybox buttons were hide)
function buttonClick(allButtons) {
  for (const button of allButtons) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.classList.contains('modal__nav-link--next')) {
        const fancyNext = document.querySelector('.is-next');
        fancyNext.click();
      } else {
        const fancyNext = document.querySelector('.is-prev');
        fancyNext.click();
      }
    });
  }
}

const allPrevButtons = document.querySelectorAll('.modal__nav-link--prev');
const allNextButtons = document.querySelectorAll('.modal__nav-link--next');
buttonClick(allNextButtons);
buttonClick(allPrevButtons);

function limitExcerpt(str, num) {
  const len = str.innerHTML.length;
  if (len <= num) return;
  str.innerHTML = str.innerHTML.substring(0, num) + "...";
}

const exc = document.querySelectorAll('.tjs-our-portfolio__article-excerpt');
if (exc.length !== 0) {
  exc.forEach(el => {
    limitExcerpt(el, 83);
  });
}

if (exitedBtn) {
  exitedBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const categoryId = btn.dataset.catId;
    const currentOption = document.querySelector(`option[value="${categoryId}"]`);
    if (currentOption !== null) {
      currentOption.selected = 'selected';
      const changeEvent = new Event('change');
      currentOption.parentElement.dispatchEvent(changeEvent);
    }
  });
}

//get current element from url params
function urlParamOptionLoop(param, allElem) {
  const allCommittee = allElem.querySelectorAll('option[value]');
  for (const el of allCommittee) {
    if (sanitizedURLVal(el.textContent) === param) {
      el.selected = 'selected';
      break;
    }
  }
}

window.addEventListener('load', () => {
  //Filter articles by GET parameter
  let currentOption;

  if (getURLparams().in && getURLparams().st) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().in, industryFilter);
    urlParamOptionLoop(getURLparams().st, currentFilter);
  } else if (getURLparams().in) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().in, industryFilter);
  } else if (getURLparams().st) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().st, currentFilter);
  }

  if (currentOption) {
    searchArticles();
    initSelect();
  }
});
